import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  IconButton,
  Menu,
  MenuItem,
  Fade
} from '@mui/material';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png';
import { Menu as MenuIcon } from '@mui/icons-material';

const MotionBox = motion(Box);

function Home() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openKvkkPdf = () => {
    window.open('/kvkk.pdf', '_blank');
    handleClose();
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
        position: 'relative'
      }}
    >
      {/* KVKK Menu */}
      <Box sx={{ position: 'absolute', top: 16, left: 16 }}>
        <IconButton
          onClick={handleMenuClick}
          sx={{ 
            color: 'primary.main',
            '&:hover': {
              background: 'rgba(0, 191, 13, 0.1)'
            }
          }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={openKvkkPdf}>KVKK Aydınlatma Metni</MenuItem>
        </Menu>
      </Box>

      <Container maxWidth="md">
        <Stack
          spacing={4}
          sx={{
            minHeight: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            py: 4
          }}
        >
          <MotionBox
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <motion.img
              src={logo}
              alt="AirUpEnglish Logo"
              style={{
                height: 80,
                width: 'auto',
                marginBottom: 32
              }}
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            />
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                fontWeight: 700,
                background: 'linear-gradient(45deg, #00bf0d, #4cf13d)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 2
              }}
            >
              AirUP English
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'text.secondary',
                maxWidth: 600,
                mx: 'auto',
                mb: 4,
                lineHeight: 1.6
              }}
            >
              İngilizce öğrenmenin en etkili ve eğlenceli yolu. Hemen başlayın ve dil öğrenme yolculuğunuza adım atın.
            </Typography>
          </MotionBox>

          <MotionBox
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{ justifyContent: 'center' }}
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/login')}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  background: 'linear-gradient(45deg, #00bf0d 30%, #4cf13d 90%)',
                  boxShadow: '0 3px 5px 2px rgba(0, 191, 13, .3)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #00bf0d 60%, #4cf13d 90%)',
                    boxShadow: '0 4px 10px 2px rgba(0, 191, 13, .4)',
                  }
                }}
              >
                Giriş Yap
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => navigate('/register')}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  borderColor: '#00bf0d',
                  color: '#00bf0d',
                  '&:hover': {
                    borderColor: '#00bf0d',
                    background: 'rgba(0, 191, 13, 0.1)',
                  }
                }}
              >
                Kayıt Ol
              </Button>
            </Stack>
          </MotionBox>

          <MotionBox
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ maxWidth: 500, mx: 'auto', mt: 4 }}
            >
              Premium üyelik ile sınırsız kelime öğrenin ve özel içeriklere erişin.
            </Typography>
          </MotionBox>
        </Stack>
      </Container>
    </Box>
  );
}

export default Home; 